import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ExpressInsiderLockIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--express-insider-lock-icon')}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M15.724 2.531a5.337 5.337 0 015.324 5.324v4.677a9.193 9.193 0 11-10.648 0l.001-4.677a5.337 5.337 0 015.323-5.324zm0 9.803a7.693 7.693 0 100 15.386 7.693 7.693 0 000-15.386zm.193 3.706c1.107 0 2.01.903 2.01 2.009v3.041a2.013 2.013 0 01-2.01 2.009h-.386a2.012 2.012 0 01-2.008-2.009V18.05c0-1.106.902-2.009 2.008-2.009h.386zm0 1.5h-.386a.513.513 0 00-.508.509v3.041c0 .278.23.509.508.509h.386c.278 0 .51-.231.51-.509V18.05a.513.513 0 00-.51-.509zm-.193-13.509a3.837 3.837 0 00-3.823 3.824v3.81a9.159 9.159 0 013.823-.831c1.365 0 2.66.297 3.824.83v-3.81a3.837 3.837 0 00-3.824-3.823z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default ExpressInsiderLockIcon;
